
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.38 136.97"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"CMS"}},[_c('circle',{staticClass:"cls-1",attrs:{"cx":"28.69","cy":"32","r":"16","fill":"#fff"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"121.69","cy":"32","r":"16","fill":"#fff"}}),_c('path',{staticClass:"cls-2",attrs:{"opacity":".54","d":"M103 64.67v68.05A108.33 108.33 0 0175.39 137c-8.27 0-14.52-.07-29.38-5.07V64.61s-1.68-26.3 28.5-26.3c.01 0 28.49-.47 28.49 26.36z"}}),_c('circle',{staticClass:"cls-2",attrs:{"opacity":".54","cx":"74.69","cy":"16","r":"16"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M57 80.67c0-26.84-28.5-26.53-28.5-26.53C-1.66 54.14 0 80.28 0 80.28c4.9 38 37 50.43 57 54.84zM121.7 54.14C91.52 54.14 93 80.57 93 80.57v54.55c55-9.93 57.27-54.84 57.27-54.84h.09c.02-26-28.66-26.14-28.66-26.14z"}})])])])
          )
        }
      }
    